const getWordPronunciation = (item,that) => {
    let wordAudio = null;

    // 优先获取服务器音频文件
    that.$axios.get("/api/v1/word/audio?word=" + item, {
        headers: {
            isLoading: false
        }
    }).then((res) => {
        console.log(res);

        if (res.data.audioUrl === "") {
            that.$axios.post("/api/tts/convert?text=" + item, {}, {

                headers: {
                    isLoading: false
                }
            }).then((response) => {
                console.log(response, 121);


                if (response.code === 200) {
                    let raw = window.atob(response.data);
                    let rawLength = raw.length;
                    let uInt8Array = new Uint8Array(rawLength);
                    for (let i = 0; i < rawLength; ++i) {
                        uInt8Array[i] = raw.charCodeAt(i);
                    }
                    const boleb= new Blob([uInt8Array]);
                    let objectURL = URL.createObjectURL(boleb);
                    wordAudio = new Audio(objectURL);
                    wordAudio.play();
                } else {
                    that.$message.error(response.msg);
                }

            });
        }else{
            wordAudio = new Audio(res.data.audioUrl);
            wordAudio.play();
        }
    });
}

export {
    getWordPronunciation
} ;